import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../urls";
//axios
import axios from "../../utilies/axios";
//_________________________________________________

// GET =>  All ALL DEPARTMENTS SERVICE
export const getAllDepartmentsService = createAsyncThunk(
  "departments/getAllDepartmentsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.departmentsURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST =>  CREATE DEPARTMENT SERVICE
export const createDepartmentService = createAsyncThunk(
  "departments/createDepartmentService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.departmentsURL, data, {
        headers: {
          Accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// DELETE =>  DELETE DEPARTMENT SERVICE
export const deleteDepartmentService = createAsyncThunk(
  "departments/deleteDepartmentService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.departmentsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// UPDATE =>  UPDATE DEPARTMENT SERVICE
export const updateDepartmentService = createAsyncThunk(
  "departments/updateDepartmentService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.departmentsURL}/${params?.id}`,
        params.formData
      , {
        headers: {
          Accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  GET DEPARTMENT BY ID SERVICE
export const getDepartmentByIdService = createAsyncThunk(
  "departments/getDepartmentByIdService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.departmentsURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
